window.track = function(category, action, label) {
  if(typeof(window.gtag) == "undefined") return;
  var sampleRate = 1;
  if(category == "Editor" || category == "Images") {
    sampleRate = 1000;
  }
  if(sampleRate > 1 && Math.random() > 1/sampleRate) {
    return;
  }
  window.gtag("event", action, {
    'event_category': category,
    'event_label': label,
  })
}
